// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ScreensCarousel__wrapper__xQ6MG","layout":"ScreensCarousel__layout__yplQf","container":"ScreensCarousel__container__2cJ1N","screen":"ScreensCarousel__screen__1uort"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexPage/ScreensCarousel.scss
// module id = 674
// module chunks = 0